import { useCallback } from 'react';
import { Cell } from 'src/components/organisms/DataTable/types';
import { FurnitureColumnType } from 'src/domain/models/FurnitureColumnType';
import { StoreInventoryRow } from 'src/domain/table/store-inventory.row';
import { useStoreInventoryUnsavedChanges } from './save-changes/useStoreInventoryUnsavedChanges';
import { useStoreInventorySimulationRows } from './table/useStoreInventorySimulationRows';

export const useStoreInventoryHandleCellChanges = () => {
    const { data: rows } = useStoreInventorySimulationRows();
    const [updatedRows, setUnsavedChanges] = useStoreInventoryUnsavedChanges();

    const handleCellChange = useCallback(
        (cells: Cell<number>[]) => {
            for (const cell of cells) {
                const rowId = Number(cell.rowId);
                const existingUnsavedChanges = updatedRows.get(rowId);
                const existingRow = rows.find((r) => r.id === rowId);

                if (!existingRow) continue;

                if (cell.column) {
                    const columnKey = cell.column.replace('furnitureColumns.', '');
                    const currentValue = existingRow.furnitureColumns?.[columnKey] as FurnitureColumnType;
                    const updatedRow: Partial<StoreInventoryRow> = {
                        ...existingUnsavedChanges,
                        furnitureColumns: {
                            ...existingUnsavedChanges?.furnitureColumns,
                            [columnKey]: currentValue,
                        },
                    };

                    if ((updatedRow.furnitureColumns?.[columnKey] as FurnitureColumnType).optionCount !== cell.value) {
                        (updatedRow.furnitureColumns?.[columnKey] as FurnitureColumnType).optionCount = cell.value;
                    }
                    updatedRows.set(rowId, updatedRow);
                }
            }
            setUnsavedChanges(updatedRows);
        },
        [rows, updatedRows, setUnsavedChanges]
    );

    return handleCellChange;
};
